export default {
    computed: {
        userId() {
            let userData = User || null;

            if (!userData) {
                return null;
            }

            return User.id;
        },
        userHasEmail() {
            let userData = User || null;

            if (!userData) {
                return null;
            }

            return userData.has_email;
        },
    },
    methods: {
        can(ability) {
            if (ability === 'register-items') {
                return User.group === 'admins';
            }
            return is_allowed(ability) || user_can(ability);
        },
    },
};
